import { render, staticRenderFns } from "./licenseList.vue?vue&type=template&id=f5e96fe2&scoped=true"
import script from "./licenseList.vue?vue&type=script&lang=js"
export * from "./licenseList.vue?vue&type=script&lang=js"
import style0 from "./licenseList.vue?vue&type=style&index=0&id=f5e96fe2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e96fe2",
  null
  
)

export default component.exports